import CommonLookupDisplay from "components/CommonLookupDisplay";
import { GlobalContext } from "components/GlobalContext";
import { createFilterableArrayColumnDefinition, IColumnDefinition } from "components/SortableTable";
import IProductCategory, { IProductCategoryCreateOrUpdate, IProductCategoryFilters, IProductCategoryInitResult } from "models/sql/IProductCategory";
import { useContext, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import ProductCategoryService from "services/ProductCategoryService";
import { useNavigate } from "react-router-dom";

interface IProductCategoriesLookupProps {
    baseData?: IProductCategoryInitResult;
}

const ProductCategoriesLookup = (props: IProductCategoriesLookupProps) => {
    const [filter, setFilter] = useState<IProductCategoryFilters>({});
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const navigate = useNavigate();

    const getColumns = (): IColumnDefinition<IProductCategory, IProductCategoryFilters>[] => {
        return [
            createFilterableArrayColumnDefinition<IProductCategory, IProductCategoryFilters>(
                globalContext,
                "name",
                "names",
                true,
                filter,
                undefined,
                (value, row) => <td className="align-top" key={`name${row.productCategoryId}`}>
                    {value}</td>),
            {
                propName: "created",
                title: "Created",
                sortable: true,
                customRenderer(value, row, allData) {
                    return <td className="align-top" key={`created${row.productCategoryId}`}>{new Date(value).toLocaleDateString()}</td>;
                },
            },
            {
                propName: "publish",
                title: "Published",
                sortable: true,
                customRenderer(value, row, allData) {
                    return <td className="align-top" key={`published${row.productCategoryId}`}>{value ? "True" : "False"}</td>;
                },
            },
        ];
    };

    const getTools = () => [
        <>
            {
                globalContext.roles.some(r => r === "Web.Admin") &&
                <Button
                    key="createnew"
                    variant="success"
                    className="full-sm"
                    onClick={() => { navigate(`/ProductCategories/Detail/`) }}>Create New</Button>
            }
        </>
    ];

    return (
        <CommonLookupDisplay<IProductCategoryFilters, IProductCategory, IProductCategoryCreateOrUpdate>
            baseFilters={{
                sortBys: ["name"],
                sortDescending: true
            }}
            filterHints={{
                names: "Array",
                published: "Boolean",
                sortBys: "Array",
                sortDescending: "Boolean"
            }}
            dataTypeName="ProductCategory"
            dataTypeNamePlural="ProductCategories"
            pathName="ProductCategories"
            primaryIdKey="productCategoryId"
            className=""
            filter={filter}
            setFilter={setFilter}
            columnDefinitions={getColumns()}
            service={ProductCategoryService}
            tools={getTools()}
        />
    );
}

export default ProductCategoriesLookup;
